import { createSlice } from "@reduxjs/toolkit";
import { getLanguages } from "../services/languagesService";

let initialState = {
  isLoading: false,
  data: [],
  pages: 0,
  errors: null
};

const languagesSlice = createSlice({
  name: "timezone",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getLanguages.pending, (state) => {
      state.isLoading = true;
      state.errors = null;
    })
    builder.addCase(getLanguages.fulfilled, (state, { payload }) => {
      state.isLoading = false;
      state.data = payload.data;
      state.errors = null;
    })
    builder.addCase(getLanguages.rejected, (state) => {
      state.isLoading = false;
      state.errors = [{ msg: "something went wrong!" }];
    })
  }
});

export default languagesSlice.reducer;